/* global toggleHideClass */
const showMoreBtn = document.querySelector('.order-list__read-more.show-more');
const showLessBtn = document.querySelector('.order-list__read-more.show-less');

const toggleButtonClass = (toggle) => {
  toggleHideClass(showMoreBtn, toggle);
  toggleHideClass(showLessBtn, !toggle);
};

attachEvent('.order-list__read-more.show-more', 'click', (ev) => {
  const hiddenItems = document.querySelectorAll('.order-list__item.hide');

  hiddenItems.forEach((el, i) => {
    if (i < 5) {
      toggleHideClass(el, false);
    }

    const remainingItems = document.querySelectorAll('.order-list__item.hide');

    if (remainingItems.length === 0) {
      toggleButtonClass(true);
    }
  });

  ev.preventDefault();
});

attachEvent('.order-list__read-more.show-less', 'click', (ev) => {
  const orderItems = document.querySelectorAll('.order-list__item');
  orderItems.forEach((el, i) => {
    if (i > 4) {
      toggleHideClass(el, true);
    }
  });

  toggleButtonClass(false);

  ev.preventDefault();
});
